<template>
  <div
    style="position:relative;display:flex;flex-direction: column;"
  >
    <div
        style="padding: 25px;text-align:left;z-index:4;border-bottom: 1px solid rgba(0,0,0,0.1);background:white;padding-top: var(--mobile-padding-top, 25px);"
    >
        <div
            v-if="xcase && xcase.case_type"
            style="display:flex;align-items: center;"
        >
            <div
                v-if="xcase.case_type.icon"
            >
                <img
                    :src="getIconPath(xcase.case_type.id)"
                    style="aspect-ratio: 1/1; max-height: 65px;margin-right: 20px;"
                />
            </div>
            <div
                style="flex-grow: 1;"
            >
                <div
                    style="font-size: 24px;font-weight: bold;"
                >
                    {{ xcase.case_type.name }}
                </div>
                <div
                    v-if="xcase.case_title"
                    style="font-size: 16px;"
                >
                    {{ xcase.case_title }}
                </div>
                <div
                    v-if="xcase.case_number"
                    style="font-size: 16px;"
                >
                    {{ xcase.case_number }}
                </div>
            </div>
        </div>
    </div>
    <div
        class="standard-content"
        :class="{ 'mobile-content': $vuetify.breakpoint.xs}"
    >
        <v-layout
            row
            wrap
            fill-height
        >
            <v-flex
                xs12
                sm12
                md6
                lg8
                class="form-feed"
                :class="{'mobile': $vuetify.breakpoint.smAndDown}"
            >
                <div
                    v-if="availableForms.length == 0"
                >
                    <div
                        class="last-message"
                        style="padding: 10px;margin:auto;font-size:16px;vertical-align:middle;text-align:center;opacity:0.3;z-index:0;border-radius: 10px;background-color: rgba(0,0,0,0.06);"
                    >
                        <div
                        >
                            <v-icon
                                color="262626"
                                size="72"
                            >
                                mdi-tray
                            </v-icon>
                            <br />
                            <span><br /><b>No forms require your attention</b></span>
                        </div>
                    </div>
                </div>
                <v-layout
                    v-else
                    row
                    wrap
                >
                    <v-flex
                        xs12
                    >
                        <div
                            style="font-size: 18px;display: flex;flex-direction: row;align-items: center;"
                        >
                            <div>
                                <v-icon
                                    size="36"
                                >
                                    mdi-chevron-down
                                </v-icon>
                            </div>
                            <div>
                                Incomplete Forms
                            </div>
                        </div>
                    </v-flex>
                    <v-flex
                        v-for="form in availableForms"
                        :key="form.id"
                        xs12
                        sm12
                        md12
                        lg6
                        class="standard-form-card"
                        :class="{ 'mobile-form-card': $vuetify.breakpoint.xs}"
                    >
                        <v-card    
                            class="form-card"
                            style="cursor:pointer;"
                            @click="$router.push({ name: 'ClientForm', params: { id: $route.params.id, form_id: form.id } })"
                        >
                            <v-card-text
                                style="border-bottom: 1px solid rgba(0,0,0,0.1);display: flex;justify-content: center;align-items: center;"
                            >
                                <div
                                    style="padding-right: 10px;"
                                >
                                    <v-icon
                                        size="36"
                                    >
                                        mdi-file-document
                                    </v-icon>
                                </div>
                                <div
                                    style="font-size: 16px;font-weight: bold;flex-grow: 1;"
                                >
                                    {{form.name}}

                                    <span
                                        v-if="form.party_name"
                                        style="font-weight: bold;"
                                    >
                                        - {{form.party_name}}
                                    </span>
                                    <span
                                        v-if="form.form_number"
                                        style="font-style: italic;font-weight: 300;"
                                    >
                                        ({{form.form_number}})
                                    </span>
                                </div>
                                <v-btn
                                    v-if="form.is_signing"
                                    color="warning"
                                    small
                                    depressed
                                >
                                    Sign Form
                                </v-btn>
                                <v-btn
                                    v-else-if="form.is_new"
                                    color="green"
                                    dark
                                    small
                                    depressed
                                >
                                    Start Form
                                </v-btn>
                                <v-btn
                                    v-else
                                    color="primary"
                                    small
                                    depressed
                                >
                                    Open Form
                                </v-btn>
                            </v-card-text>
                        </v-card>
                    </v-flex>
                </v-layout>
                <div
                    style="margin-top: 20px;"
                >
                    <v-layout
                        v-if="unavailableForms.length > 0"
                        row
                        wrap
                    >
                        <v-flex
                            xs12
                        >
                            <div
                                style="font-size: 18px;display: flex;flex-direction: row;align-items: center;"
                            >
                                <div>
                                    <v-icon
                                        size="36"
                                    >
                                        mdi-chevron-down
                                    </v-icon>
                                </div>
                                <div>
                                    Submitted Forms
                                </div>
                            </div>
                        </v-flex>
                        <v-flex
                            v-for="form in unavailableForms"
                            :key="form.id"
                            xs12
                            sm12
                            md12
                            lg6
                            class="standard-form-card"
                            :class="{ 'mobile-form-card': $vuetify.breakpoint.xs}"
                        >
                            <v-card  
                                class="form-card"
                                style="cursor:pointer;"
                                :to="{ name: 'ClientForm', params: { id: $route.params.id, form_id: form.id } }"
                            >
                                <v-card-text
                                    style="border-bottom: 1px solid rgba(0,0,0,0.1);display: flex;justify-content: center;align-items: center;"
                                >
                                    <div
                                        style="padding-right: 10px;"
                                    >
                                        <v-icon
                                            size="36"
                                        >
                                            mdi-file-document
                                        </v-icon>
                                    </div>
                                    <div
                                        style="font-size: 16px;font-weight: bold;flex-grow: 1;"
                                    >
                                        {{form.name}}

                                        <span
                                            v-if="form.party_name"
                                            style="font-weight: bold;"
                                        >
                                            - {{form.party_name}}
                                        </span>
                                        <span
                                            v-if="form.form_number"
                                            style="font-style: italic;font-weight: 300;"
                                        >
                                            ({{form.form_number}})
                                        </span>
                                    </div>
                                    <v-btn 
                                        small
                                        depressed
                                        title="Download PDF of Completed Form"
                                        @click.prevent="downloadPdf(form)"
                                        style="min-width: unset;border-top-right-radius: unset;border-bottom-right-radius: unset;border-right: solid rgba(0,0,0,0.1) 1px;margin-right:unset;"
                                    >
                                        <v-icon>mdi-download</v-icon>
                                    </v-btn>
                                    <v-btn
                                        small
                                        depressed
                                        style="margin-left: unset;border-top-left-radius: unset;border-bottom-left-radius: unset;"
                                    >
                                        View Form
                                    </v-btn>
                                </v-card-text>
                            </v-card>
                        </v-flex>
                    </v-layout>
                </div>
            </v-flex>
            <v-flex
                v-if="case_news.length > 0"
                xs12
                sm12
                md6
                lg4
                class="news-feed"
                :class="{'mobile': $vuetify.breakpoint.smAndDown}"
            >
                <div
                    v-if="xcase && xcase.case_type"
                    style="font-size: 16px;font-weight: bold;padding-left: 5px;"
                >
                    Latest {{ xcase.case_type.name }} News
                </div>
                <div
                    style="padding: 10px 0;"
                >
                    <div
                        v-for="article in case_news"
                        :key="article.id"
                    >
                        <NewsCard
                            :article="article"
                            style="margin-bottom: 15px;"
                        />
                    </div>
                    <div
                        v-if="moreNews"
                        style="text-align: center;"
                    >
                        <v-btn
                            @click="newsPage = newsPage + 1;fetchNews()"
                            :disabled="loading_news"
                            :loading="loading_news"
                            depressed
                            color="primary"
                            dark
                        >
                            Load More Articles
                        </v-btn>
                    </div>
                </div>
            </v-flex>
        </v-layout>
    </div>
  </div>
</template>

<script>
import api from '@/api'
import { mapMutations, mapGetters, mapState, mapActions } from 'vuex'

const STATUS_INITIAL = 0, STATUS_SAVING = 1, STATUS_SUCCESS = 2, STATUS_FAILED = 3
import NewsCard from '../../NewsCard.vue'

export default {
    name: 'Forms',
    components: {
        NewsCard
    },
    data () {
        return {
            xcase: {},
            loading: false,
            loading_news: false,
            case_news: [],
            newsPage: 1,
            moreNews: false
        }
    },
    created () {
        this.fetchForms()
    },
    methods: {
        fetchForms () {
            this.loading = true
            api.userform.contactCases.get(this.$route.params.id)
                .then(data => {
                    this.xcase = data
                    this.loading = false
                    this.fetchNews()
                })
        },
        fetchNews () {
            if (!this.loading_news) {
                this.loading_news = true
                api.news.casenews.list({casetype: this.xcase.case_type.id, pageNum: this.newsPage})
                    .then((data) => {
                        if (data.next_page)
                            this.moreNews = true
                        else
                            this.moreNews = false
                        this.case_news = this.case_news.concat(data.results)
                    })
                    .finally(() => {
                        this.loading_news = false
                    })
            }
        },
        getIconPath (id) {
            return api.cases.casetype.icon(id)
        },
        downloadPdf (form) {
          api.userform.userForm.downloadContactPdf(form.id)
            .then(response => {
              let blob = new Blob([response.data])
              let link = document.createElement('a')
              link.href = window.URL.createObjectURL(blob)
              link.download = form.name + '.pdf'
              link.click()
            })
        }
    },
    computed: {
        ...mapGetters('userform', [
            'signedForms',
        ]),
        availableForms () {
            var forms = []
            if (!this.loading)
                this.xcase.userforms.filter((form) => {
                    if ((!form.client_readonly || form.is_signing) && !this.signedForms.includes(form.id)) {
                        forms.push(form)
                    }
                })
            return forms
        },
        unavailableForms () {
            var forms = []
            if (!this.loading)
                this.xcase.userforms.filter((form) => {
                    if (form.client_readonly || this.signedForms.includes(form.id)) {
                        forms.push(form)
                    }
                })
            return forms
        }
    }
}
</script>

<style scoped>
    .standard-content {
        max-height: calc(100vh - 135px);
        height:100vh;
        overflow-y:auto;
        position: relative;
    }
    .mobile-content {
        max-height: calc(100vh - 135px - 56px - var(--mobile-padding-bottom)) !important;
        position: relative;
    }

    .form-card {
        position: relative;
    }

    .standard-form-card {
        padding-right: 15px;
        padding-top: 15px;
    }

    .mobile-form-card {
        padding-top: 15px;
        padding-right: 0 !important;
    }

    .news-feed {
        background-color: #E0E0E0;
        overflow-y: auto;
        z-index:9;
        align-self: stretch;
        padding: 10px;
        max-height: calc(100vh - 135px)
    }

    .news-feed.mobile {
        order: 1;
        align-self: unset;
        max-height: 50vh;
        box-shadow: 0 3px 1px -2px rgba(0,0,0,.2),0 2px 2px 0 rgba(0,0,0,.14),0 1px 5px 0 rgba(0,0,0,.12);
    }

    .form-feed {
        padding: 15px;
    }

    .form-feed.mobile {
        order: 2;
    }
</style>